import { Item } from '../Types/Item';

export const items: Item[] = [
    { date: new Date(2022, 3, 3), category: 'food', title: 'MacDonalds', price: 30.12 },
    { date: new Date(2022, 3, 3), category: 'food', title: 'Burguer King', price: 23.12 },
    { date: new Date(2022, 4, 5), category: 'rent', title: 'Aluguel Apto', price: 2300.00 },
    { date: new Date(2022, 4, 1), category: 'salary', title: 'Salário DevTwo', price: 5000.00 },
];